import { inject as Wt, getCurrentScope as Ht, onScopeDispose as Et, unref as z, reactive as Ee, computed as M, ref as x, watch as J, defineComponent as ye, renderSlot as Ft, provide as de, onBeforeUnmount as Nt, h as _, onMounted as zt, nextTick as qt, getCurrentInstance as It, toRef as Gt, readonly as Yt, customRef as Jt, isRef as Kt, watchEffect as Qt, useCssVars as Xt, defineAsyncComponent as Fe, openBlock as Ne, createElementBlock as Zt, createVNode as ze, withCtx as Ie, createBlock as en, resolveDynamicComponent as tn, createCommentVNode as nn } from "vue";
const rn = (e, n, t) => {
  const o = e[n];
  return o ? typeof o == "function" ? o() : Promise.resolve(o) : new Promise((r, i) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      i.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + n + (n.split("/").length !== t ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
}, Rt = Symbol("theme"), on = {
  mainColor: {
    base: "#333333",
    over: "#2CB0B8",
    contrasted: "#FFFFFF"
  },
  fontColor: "#333333",
  actionColor: {
    base: "#32BFC8",
    washed: "rgba(51, 51, 51, 0.24)",
    over: "#2CB0B8",
    contrasted: "#FFFFFF"
  },
  actionContrastColor: {
    base: "#FFFFFF",
    over: "#333333",
    contrasted: "#333333"
  },
  backgroundColor: {
    base: "#FFFFFF",
    over: "#2CB0B8",
    washed: "rgba(51, 51, 51, 0.24)",
    dimmed: "rgba(51, 51, 51, 0.24)",
    contrasted: "#333333"
  },
  backgroundHighlight: !0,
  border: !1,
  borderColor: "#333333",
  borderRadius: "8px"
}, an = () => Wt(Rt, on);
function sn(e, n) {
  return n ? Object.keys(n).reduce(
    (t, o) => t.replace(`{${o}}`, n[o].toString()),
    e
  ) : e;
}
const ln = Symbol("i18n");
function cn(e) {
  return Ht() ? (Et(e), !0) : !1;
}
function $t(e) {
  return typeof e == "function" ? e() : z(e);
}
const un = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const dn = Object.prototype.toString, gn = (e) => dn.call(e) === "[object Object]", pe = () => {
};
function fn(e) {
  var n;
  const t = $t(e);
  return (n = t == null ? void 0 : t.$el) != null ? n : t;
}
const Ot = un ? window : void 0;
function he(...e) {
  let n, t, o, r;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([t, o, r] = e, n = Ot) : [n, t, o, r] = e, !n)
    return pe;
  Array.isArray(t) || (t = [t]), Array.isArray(o) || (o = [o]);
  const i = [], a = () => {
    i.forEach((d) => d()), i.length = 0;
  }, s = (d, g, p, h) => (d.addEventListener(g, p, h), () => d.removeEventListener(g, p, h)), l = J(
    () => [fn(n), $t(r)],
    ([d, g]) => {
      if (a(), !d)
        return;
      const p = gn(g) ? { ...g } : g;
      i.push(
        ...t.flatMap((h) => o.map((w) => s(d, h, w, p)))
      );
    },
    { immediate: !0, flush: "post" }
  ), u = () => {
    l(), a();
  };
  return cn(u), u;
}
function hn(e, n = {}) {
  const {
    threshold: t = 50,
    onSwipe: o,
    onSwipeEnd: r,
    onSwipeStart: i,
    passive: a = !0,
    window: s = Ot
  } = n, l = Ee({ x: 0, y: 0 }), u = Ee({ x: 0, y: 0 }), d = M(() => l.x - u.x), g = M(() => l.y - u.y), { max: p, abs: h } = Math, w = M(() => p(h(d.value), h(g.value)) >= t), y = x(!1), A = M(() => w.value ? h(d.value) > h(g.value) ? d.value > 0 ? "left" : "right" : g.value > 0 ? "up" : "down" : "none"), E = (v) => [v.touches[0].clientX, v.touches[0].clientY], B = (v, m) => {
    l.x = v, l.y = m;
  }, U = (v, m) => {
    u.x = v, u.y = m;
  };
  let k;
  const F = mn(s == null ? void 0 : s.document);
  a ? k = F ? { passive: !0 } : { capture: !1 } : k = F ? { passive: !1, capture: !0 } : { capture: !0 };
  const Q = (v) => {
    y.value && (r == null || r(v, A.value)), y.value = !1;
  }, R = [
    he(e, "touchstart", (v) => {
      if (v.touches.length !== 1)
        return;
      k.capture && !k.passive && v.preventDefault();
      const [m, C] = E(v);
      B(m, C), U(m, C), i == null || i(v);
    }, k),
    he(e, "touchmove", (v) => {
      if (v.touches.length !== 1)
        return;
      const [m, C] = E(v);
      U(m, C), !y.value && w.value && (y.value = !0), y.value && (o == null || o(v));
    }, k),
    he(e, ["touchend", "touchcancel"], Q, k)
  ];
  return {
    isPassiveEventSupported: F,
    isSwiping: y,
    direction: A,
    coordsStart: l,
    coordsEnd: u,
    lengthX: d,
    lengthY: g,
    stop: () => R.forEach((v) => v())
  };
}
function mn(e) {
  if (!e)
    return !1;
  let n = !1;
  const t = {
    get passive() {
      return n = !0, !1;
    }
  };
  return e.addEventListener("x", pe, t), e.removeEventListener("x", pe), n;
}
function ue(e) {
  "@babel/helpers - typeof";
  return ue = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, ue(e);
}
var vn = /^\s+/, pn = /\s+$/;
function c(e, n) {
  if (e = e || "", n = n || {}, e instanceof c)
    return e;
  if (!(this instanceof c))
    return new c(e, n);
  var t = bn(e);
  this._originalInput = e, this._r = t.r, this._g = t.g, this._b = t.b, this._a = t.a, this._roundA = Math.round(100 * this._a) / 100, this._format = n.format || t.format, this._gradientType = n.gradientType, this._r < 1 && (this._r = Math.round(this._r)), this._g < 1 && (this._g = Math.round(this._g)), this._b < 1 && (this._b = Math.round(this._b)), this._ok = t.ok;
}
c.prototype = {
  isDark: function() {
    return this.getBrightness() < 128;
  },
  isLight: function() {
    return !this.isDark();
  },
  isValid: function() {
    return this._ok;
  },
  getOriginalInput: function() {
    return this._originalInput;
  },
  getFormat: function() {
    return this._format;
  },
  getAlpha: function() {
    return this._a;
  },
  getBrightness: function() {
    var e = this.toRgb();
    return (e.r * 299 + e.g * 587 + e.b * 114) / 1e3;
  },
  getLuminance: function() {
    var e = this.toRgb(), n, t, o, r, i, a;
    return n = e.r / 255, t = e.g / 255, o = e.b / 255, n <= 0.03928 ? r = n / 12.92 : r = Math.pow((n + 0.055) / 1.055, 2.4), t <= 0.03928 ? i = t / 12.92 : i = Math.pow((t + 0.055) / 1.055, 2.4), o <= 0.03928 ? a = o / 12.92 : a = Math.pow((o + 0.055) / 1.055, 2.4), 0.2126 * r + 0.7152 * i + 0.0722 * a;
  },
  setAlpha: function(e) {
    return this._a = Bt(e), this._roundA = Math.round(100 * this._a) / 100, this;
  },
  toHsv: function() {
    var e = $e(this._r, this._g, this._b);
    return {
      h: e.h * 360,
      s: e.s,
      v: e.v,
      a: this._a
    };
  },
  toHsvString: function() {
    var e = $e(this._r, this._g, this._b), n = Math.round(e.h * 360), t = Math.round(e.s * 100), o = Math.round(e.v * 100);
    return this._a == 1 ? "hsv(" + n + ", " + t + "%, " + o + "%)" : "hsva(" + n + ", " + t + "%, " + o + "%, " + this._roundA + ")";
  },
  toHsl: function() {
    var e = Re(this._r, this._g, this._b);
    return {
      h: e.h * 360,
      s: e.s,
      l: e.l,
      a: this._a
    };
  },
  toHslString: function() {
    var e = Re(this._r, this._g, this._b), n = Math.round(e.h * 360), t = Math.round(e.s * 100), o = Math.round(e.l * 100);
    return this._a == 1 ? "hsl(" + n + ", " + t + "%, " + o + "%)" : "hsla(" + n + ", " + t + "%, " + o + "%, " + this._roundA + ")";
  },
  toHex: function(e) {
    return Oe(this._r, this._g, this._b, e);
  },
  toHexString: function(e) {
    return "#" + this.toHex(e);
  },
  toHex8: function(e) {
    return Sn(this._r, this._g, this._b, this._a, e);
  },
  toHex8String: function(e) {
    return "#" + this.toHex8(e);
  },
  toRgb: function() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function() {
    return {
      r: Math.round(b(this._r, 255) * 100) + "%",
      g: Math.round(b(this._g, 255) * 100) + "%",
      b: Math.round(b(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(b(this._r, 255) * 100) + "%, " + Math.round(b(this._g, 255) * 100) + "%, " + Math.round(b(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(b(this._r, 255) * 100) + "%, " + Math.round(b(this._g, 255) * 100) + "%, " + Math.round(b(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function() {
    return this._a === 0 ? "transparent" : this._a < 1 ? !1 : zn[Oe(this._r, this._g, this._b, !0)] || !1;
  },
  toFilter: function(e) {
    var n = "#" + Be(this._r, this._g, this._b, this._a), t = n, o = this._gradientType ? "GradientType = 1, " : "";
    if (e) {
      var r = c(e);
      t = "#" + Be(r._r, r._g, r._b, r._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + o + "startColorstr=" + n + ",endColorstr=" + t + ")";
  },
  toString: function(e) {
    var n = !!e;
    e = e || this._format;
    var t = !1, o = this._a < 1 && this._a >= 0, r = !n && o && (e === "hex" || e === "hex6" || e === "hex3" || e === "hex4" || e === "hex8" || e === "name");
    return r ? e === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (e === "rgb" && (t = this.toRgbString()), e === "prgb" && (t = this.toPercentageRgbString()), (e === "hex" || e === "hex6") && (t = this.toHexString()), e === "hex3" && (t = this.toHexString(!0)), e === "hex4" && (t = this.toHex8String(!0)), e === "hex8" && (t = this.toHex8String()), e === "name" && (t = this.toName()), e === "hsl" && (t = this.toHslString()), e === "hsv" && (t = this.toHsvString()), t || this.toHexString());
  },
  clone: function() {
    return c(this.toString());
  },
  _applyModification: function(e, n) {
    var t = e.apply(null, [this].concat([].slice.call(n)));
    return this._r = t._r, this._g = t._g, this._b = t._b, this.setAlpha(t._a), this;
  },
  lighten: function() {
    return this._applyModification(An, arguments);
  },
  brighten: function() {
    return this._applyModification(kn, arguments);
  },
  darken: function() {
    return this._applyModification(Ln, arguments);
  },
  desaturate: function() {
    return this._applyModification(Mn, arguments);
  },
  saturate: function() {
    return this._applyModification(xn, arguments);
  },
  greyscale: function() {
    return this._applyModification(_n, arguments);
  },
  spin: function() {
    return this._applyModification(Tn, arguments);
  },
  _applyCombination: function(e, n) {
    return e.apply(null, [this].concat([].slice.call(n)));
  },
  analogous: function() {
    return this._applyCombination(Fn, arguments);
  },
  complement: function() {
    return this._applyCombination(Hn, arguments);
  },
  monochromatic: function() {
    return this._applyCombination(Nn, arguments);
  },
  splitcomplement: function() {
    return this._applyCombination(En, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function() {
    return this._applyCombination(je, [3]);
  },
  tetrad: function() {
    return this._applyCombination(je, [4]);
  }
};
c.fromRatio = function(e, n) {
  if (ue(e) == "object") {
    var t = {};
    for (var o in e)
      e.hasOwnProperty(o) && (o === "a" ? t[o] = e[o] : t[o] = se(e[o]));
    e = t;
  }
  return c(e, n);
};
function bn(e) {
  var n = {
    r: 0,
    g: 0,
    b: 0
  }, t = 1, o = null, r = null, i = null, a = !1, s = !1;
  return typeof e == "string" && (e = On(e)), ue(e) == "object" && (P(e.r) && P(e.g) && P(e.b) ? (n = wn(e.r, e.g, e.b), a = !0, s = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : P(e.h) && P(e.s) && P(e.v) ? (o = se(e.s), r = se(e.v), n = Cn(e.h, o, r), a = !0, s = "hsv") : P(e.h) && P(e.s) && P(e.l) && (o = se(e.s), i = se(e.l), n = yn(e.h, o, i), a = !0, s = "hsl"), e.hasOwnProperty("a") && (t = e.a)), t = Bt(t), {
    ok: a,
    format: e.format || s,
    r: Math.min(255, Math.max(n.r, 0)),
    g: Math.min(255, Math.max(n.g, 0)),
    b: Math.min(255, Math.max(n.b, 0)),
    a: t
  };
}
function wn(e, n, t) {
  return {
    r: b(e, 255) * 255,
    g: b(n, 255) * 255,
    b: b(t, 255) * 255
  };
}
function Re(e, n, t) {
  e = b(e, 255), n = b(n, 255), t = b(t, 255);
  var o = Math.max(e, n, t), r = Math.min(e, n, t), i, a, s = (o + r) / 2;
  if (o == r)
    i = a = 0;
  else {
    var l = o - r;
    switch (a = s > 0.5 ? l / (2 - o - r) : l / (o + r), o) {
      case e:
        i = (n - t) / l + (n < t ? 6 : 0);
        break;
      case n:
        i = (t - e) / l + 2;
        break;
      case t:
        i = (e - n) / l + 4;
        break;
    }
    i /= 6;
  }
  return {
    h: i,
    s: a,
    l: s
  };
}
function yn(e, n, t) {
  var o, r, i;
  e = b(e, 360), n = b(n, 100), t = b(t, 100);
  function a(u, d, g) {
    return g < 0 && (g += 1), g > 1 && (g -= 1), g < 1 / 6 ? u + (d - u) * 6 * g : g < 1 / 2 ? d : g < 2 / 3 ? u + (d - u) * (2 / 3 - g) * 6 : u;
  }
  if (n === 0)
    o = r = i = t;
  else {
    var s = t < 0.5 ? t * (1 + n) : t + n - t * n, l = 2 * t - s;
    o = a(l, s, e + 1 / 3), r = a(l, s, e), i = a(l, s, e - 1 / 3);
  }
  return {
    r: o * 255,
    g: r * 255,
    b: i * 255
  };
}
function $e(e, n, t) {
  e = b(e, 255), n = b(n, 255), t = b(t, 255);
  var o = Math.max(e, n, t), r = Math.min(e, n, t), i, a, s = o, l = o - r;
  if (a = o === 0 ? 0 : l / o, o == r)
    i = 0;
  else {
    switch (o) {
      case e:
        i = (n - t) / l + (n < t ? 6 : 0);
        break;
      case n:
        i = (t - e) / l + 2;
        break;
      case t:
        i = (e - n) / l + 4;
        break;
    }
    i /= 6;
  }
  return {
    h: i,
    s: a,
    v: s
  };
}
function Cn(e, n, t) {
  e = b(e, 360) * 6, n = b(n, 100), t = b(t, 100);
  var o = Math.floor(e), r = e - o, i = t * (1 - n), a = t * (1 - r * n), s = t * (1 - (1 - r) * n), l = o % 6, u = [t, a, i, i, s, t][l], d = [s, t, t, a, i, i][l], g = [i, i, s, t, t, a][l];
  return {
    r: u * 255,
    g: d * 255,
    b: g * 255
  };
}
function Oe(e, n, t, o) {
  var r = [I(Math.round(e).toString(16)), I(Math.round(n).toString(16)), I(Math.round(t).toString(16))];
  return o && r[0].charAt(0) == r[0].charAt(1) && r[1].charAt(0) == r[1].charAt(1) && r[2].charAt(0) == r[2].charAt(1) ? r[0].charAt(0) + r[1].charAt(0) + r[2].charAt(0) : r.join("");
}
function Sn(e, n, t, o, r) {
  var i = [I(Math.round(e).toString(16)), I(Math.round(n).toString(16)), I(Math.round(t).toString(16)), I(jt(o))];
  return r && i[0].charAt(0) == i[0].charAt(1) && i[1].charAt(0) == i[1].charAt(1) && i[2].charAt(0) == i[2].charAt(1) && i[3].charAt(0) == i[3].charAt(1) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) + i[3].charAt(0) : i.join("");
}
function Be(e, n, t, o) {
  var r = [I(jt(o)), I(Math.round(e).toString(16)), I(Math.round(n).toString(16)), I(Math.round(t).toString(16))];
  return r.join("");
}
c.equals = function(e, n) {
  return !e || !n ? !1 : c(e).toRgbString() == c(n).toRgbString();
};
c.random = function() {
  return c.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};
function Mn(e, n) {
  n = n === 0 ? 0 : n || 10;
  var t = c(e).toHsl();
  return t.s -= n / 100, t.s = ge(t.s), c(t);
}
function xn(e, n) {
  n = n === 0 ? 0 : n || 10;
  var t = c(e).toHsl();
  return t.s += n / 100, t.s = ge(t.s), c(t);
}
function _n(e) {
  return c(e).desaturate(100);
}
function An(e, n) {
  n = n === 0 ? 0 : n || 10;
  var t = c(e).toHsl();
  return t.l += n / 100, t.l = ge(t.l), c(t);
}
function kn(e, n) {
  n = n === 0 ? 0 : n || 10;
  var t = c(e).toRgb();
  return t.r = Math.max(0, Math.min(255, t.r - Math.round(255 * -(n / 100)))), t.g = Math.max(0, Math.min(255, t.g - Math.round(255 * -(n / 100)))), t.b = Math.max(0, Math.min(255, t.b - Math.round(255 * -(n / 100)))), c(t);
}
function Ln(e, n) {
  n = n === 0 ? 0 : n || 10;
  var t = c(e).toHsl();
  return t.l -= n / 100, t.l = ge(t.l), c(t);
}
function Tn(e, n) {
  var t = c(e).toHsl(), o = (t.h + n) % 360;
  return t.h = o < 0 ? 360 + o : o, c(t);
}
function Hn(e) {
  var n = c(e).toHsl();
  return n.h = (n.h + 180) % 360, c(n);
}
function je(e, n) {
  if (isNaN(n) || n <= 0)
    throw new Error("Argument to polyad must be a positive number");
  for (var t = c(e).toHsl(), o = [c(e)], r = 360 / n, i = 1; i < n; i++)
    o.push(c({
      h: (t.h + i * r) % 360,
      s: t.s,
      l: t.l
    }));
  return o;
}
function En(e) {
  var n = c(e).toHsl(), t = n.h;
  return [c(e), c({
    h: (t + 72) % 360,
    s: n.s,
    l: n.l
  }), c({
    h: (t + 216) % 360,
    s: n.s,
    l: n.l
  })];
}
function Fn(e, n, t) {
  n = n || 6, t = t || 30;
  var o = c(e).toHsl(), r = 360 / t, i = [c(e)];
  for (o.h = (o.h - (r * n >> 1) + 720) % 360; --n; )
    o.h = (o.h + r) % 360, i.push(c(o));
  return i;
}
function Nn(e, n) {
  n = n || 6;
  for (var t = c(e).toHsv(), o = t.h, r = t.s, i = t.v, a = [], s = 1 / n; n--; )
    a.push(c({
      h: o,
      s: r,
      v: i
    })), i = (i + s) % 1;
  return a;
}
c.mix = function(e, n, t) {
  t = t === 0 ? 0 : t || 50;
  var o = c(e).toRgb(), r = c(n).toRgb(), i = t / 100, a = {
    r: (r.r - o.r) * i + o.r,
    g: (r.g - o.g) * i + o.g,
    b: (r.b - o.b) * i + o.b,
    a: (r.a - o.a) * i + o.a
  };
  return c(a);
};
c.readability = function(e, n) {
  var t = c(e), o = c(n);
  return (Math.max(t.getLuminance(), o.getLuminance()) + 0.05) / (Math.min(t.getLuminance(), o.getLuminance()) + 0.05);
};
c.isReadable = function(e, n, t) {
  var o = c.readability(e, n), r, i;
  switch (i = !1, r = Bn(t), r.level + r.size) {
    case "AAsmall":
    case "AAAlarge":
      i = o >= 4.5;
      break;
    case "AAlarge":
      i = o >= 3;
      break;
    case "AAAsmall":
      i = o >= 7;
      break;
  }
  return i;
};
c.mostReadable = function(e, n, t) {
  var o = null, r = 0, i, a, s, l;
  t = t || {}, a = t.includeFallbackColors, s = t.level, l = t.size;
  for (var u = 0; u < n.length; u++)
    i = c.readability(e, n[u]), i > r && (r = i, o = c(n[u]));
  return c.isReadable(e, o, {
    level: s,
    size: l
  }) || !a ? o : (t.includeFallbackColors = !1, c.mostReadable(e, ["#fff", "#000"], t));
};
var be = c.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
}, zn = c.hexNames = In(be);
function In(e) {
  var n = {};
  for (var t in e)
    e.hasOwnProperty(t) && (n[e[t]] = t);
  return n;
}
function Bt(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function b(e, n) {
  Rn(e) && (e = "100%");
  var t = $n(e);
  return e = Math.min(n, Math.max(0, parseFloat(e))), t && (e = parseInt(e * n, 10) / 100), Math.abs(e - n) < 1e-6 ? 1 : e % n / parseFloat(n);
}
function ge(e) {
  return Math.min(1, Math.max(0, e));
}
function T(e) {
  return parseInt(e, 16);
}
function Rn(e) {
  return typeof e == "string" && e.indexOf(".") != -1 && parseFloat(e) === 1;
}
function $n(e) {
  return typeof e == "string" && e.indexOf("%") != -1;
}
function I(e) {
  return e.length == 1 ? "0" + e : "" + e;
}
function se(e) {
  return e <= 1 && (e = e * 100 + "%"), e;
}
function jt(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function Pe(e) {
  return T(e) / 255;
}
var N = function() {
  var e = "[-\\+]?\\d+%?", n = "[-\\+]?\\d*\\.\\d+%?", t = "(?:" + n + ")|(?:" + e + ")", o = "[\\s|\\(]+(" + t + ")[,|\\s]+(" + t + ")[,|\\s]+(" + t + ")\\s*\\)?", r = "[\\s|\\(]+(" + t + ")[,|\\s]+(" + t + ")[,|\\s]+(" + t + ")[,|\\s]+(" + t + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(t),
    rgb: new RegExp("rgb" + o),
    rgba: new RegExp("rgba" + r),
    hsl: new RegExp("hsl" + o),
    hsla: new RegExp("hsla" + r),
    hsv: new RegExp("hsv" + o),
    hsva: new RegExp("hsva" + r),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();
function P(e) {
  return !!N.CSS_UNIT.exec(e);
}
function On(e) {
  e = e.replace(vn, "").replace(pn, "").toLowerCase();
  var n = !1;
  if (be[e])
    e = be[e], n = !0;
  else if (e == "transparent")
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  var t;
  return (t = N.rgb.exec(e)) ? {
    r: t[1],
    g: t[2],
    b: t[3]
  } : (t = N.rgba.exec(e)) ? {
    r: t[1],
    g: t[2],
    b: t[3],
    a: t[4]
  } : (t = N.hsl.exec(e)) ? {
    h: t[1],
    s: t[2],
    l: t[3]
  } : (t = N.hsla.exec(e)) ? {
    h: t[1],
    s: t[2],
    l: t[3],
    a: t[4]
  } : (t = N.hsv.exec(e)) ? {
    h: t[1],
    s: t[2],
    v: t[3]
  } : (t = N.hsva.exec(e)) ? {
    h: t[1],
    s: t[2],
    v: t[3],
    a: t[4]
  } : (t = N.hex8.exec(e)) ? {
    r: T(t[1]),
    g: T(t[2]),
    b: T(t[3]),
    a: Pe(t[4]),
    format: n ? "name" : "hex8"
  } : (t = N.hex6.exec(e)) ? {
    r: T(t[1]),
    g: T(t[2]),
    b: T(t[3]),
    format: n ? "name" : "hex"
  } : (t = N.hex4.exec(e)) ? {
    r: T(t[1] + "" + t[1]),
    g: T(t[2] + "" + t[2]),
    b: T(t[3] + "" + t[3]),
    a: Pe(t[4] + "" + t[4]),
    format: n ? "name" : "hex8"
  } : (t = N.hex3.exec(e)) ? {
    r: T(t[1] + "" + t[1]),
    g: T(t[2] + "" + t[2]),
    b: T(t[3] + "" + t[3]),
    format: n ? "name" : "hex"
  } : !1;
}
function Bn(e) {
  var n, t;
  return e = e || {
    level: "AA",
    size: "small"
  }, n = (e.level || "AA").toUpperCase(), t = (e.size || "small").toLowerCase(), n !== "AA" && n !== "AAA" && (n = "AA"), t !== "small" && t !== "large" && (t = "small"), {
    level: n,
    size: t
  };
}
function H(e) {
  const n = c(e), t = () => n.getLuminance() <= 0.5;
  return {
    isDark: t,
    isLight: () => !t(),
    darken: (o) => n.darken(o).toString(),
    lighten: (o) => n.lighten(o).toString(),
    setAlpha: (o) => n.setAlpha(o).toString(),
    getLuminance: () => n.getLuminance(),
    wash: () => {
      const o = Math.min(
        (1 - n.getLuminance()) / 3,
        0.1
      );
      return n.setAlpha(o).toString();
    },
    dim: () => {
      const o = n.getLuminance(), r = o > 0.85 ? o : 0.24;
      return c("#fff").setAlpha(r).toString();
    },
    toHexString: () => n.toHexString(),
    isValid: () => n.isValid()
  };
}
const Pt = "#333333", jn = "#ffffff";
function Ce(e) {
  return e === "auto";
}
function re(e, n) {
  return !e || Ce(e) ? n : e;
}
function oe(e) {
  return !e || H(e).isDark() ? jn : Pt;
}
function Pn(e) {
  let n = e;
  for (; H(n).isLight(); )
    n = H(n).darken(1);
  return n;
}
function ce(e) {
  return H(e).getLuminance() < 0.1 ? H(e).lighten(5) : H(e).darken(5);
}
function ae(e) {
  return !e || Ce(e) || !H(e).isValid() ? "auto" : H(e).toHexString();
}
function Dn(e) {
  return e ? e.endsWith("px") ? e : `${e}px` : "0";
}
function Vn(e) {
  var n, t, o, r, i, a, s, l;
  return {
    mainColor: ae((n = e.basics) == null ? void 0 : n.mainColor),
    actionColor: ae((t = e.extra) == null ? void 0 : t.actionColor),
    backgroundColor: ae((o = e.extra) == null ? void 0 : o.backgroundColor),
    borderColor: ae((r = e.extra) == null ? void 0 : r.borderColor),
    fontColor: ae((i = e.extra) == null ? void 0 : i.fontColor),
    backgroundHighlight: (a = e.extra) != null && a.backgroundHighlight ? e.extra.backgroundHighlight === "1" : !0,
    border: ((s = e.extra) == null ? void 0 : s.border) === "1",
    borderRadius: (l = e.extra) != null && l.borderRadius ? Dn(e.extra.borderRadius) : "4px"
  };
}
function Un(e) {
  const n = Vn(e), t = H(n.mainColor).toHexString(), o = Pn(
    re(
      n.actionColor,
      n.mainColor
    )
  ), r = re(
    n.backgroundColor,
    n.mainColor
  ), i = re(
    n.actionColor,
    oe(r)
  );
  return {
    mainColor: {
      base: t,
      over: ce(t),
      contrasted: oe(t)
    },
    fontColor: re(n.fontColor, Pt),
    actionColor: {
      base: o,
      washed: H(o).wash(),
      over: ce(o),
      contrasted: oe(o)
    },
    actionContrastColor: {
      base: i,
      over: ce(i),
      contrasted: Ce(n.actionColor) ? r : oe(i)
    },
    backgroundColor: {
      base: r,
      over: ce(r),
      washed: H(r).wash(),
      dimmed: H(r).dim(),
      contrasted: oe(r)
    },
    backgroundHighlight: n.backgroundHighlight,
    border: n.border,
    borderColor: re(
      n.borderColor,
      n.mainColor
    ),
    borderRadius: n.borderRadius
  };
}
function Wn(e) {
  if (!e)
    throw new Error("Theme is required");
  de(
    Rt,
    Un(e)
  );
}
const K = ({
  langCode: e,
  mapper: n,
  number: t,
  keysLength: o
}) => {
  if (t === 0) return 0;
  const r = new Intl.PluralRules(e).select(t), i = n[r];
  return Math.min(
    o <= Object.keys(n).length ? i - 1 : i,
    o - 1
  );
}, qn = (e, n) => K({
  langCode: "en-EN",
  mapper: { one: 1, other: 2 },
  number: e,
  keysLength: n
}), Gn = (e, n) => {
  const t = new Intl.PluralRules("ar-EG").select(e), o = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
  }[t];
  return Math.min(o, n - 1);
}, me = (e, n) => K({
  langCode: "ru-RU",
  mapper: { one: 1, few: 2, many: 3 },
  number: e,
  keysLength: n
}), Yn = (e, n) => K({
  langCode: "ro-RO",
  mapper: { one: 1, few: 2, other: 3 },
  number: e,
  keysLength: n
}), Jn = (e, n) => K({
  langCode: "pl-PL",
  mapper: { one: 1, few: 2, many: 3 },
  number: e,
  keysLength: n
}), Kn = (e, n) => K({
  langCode: "is-IS",
  mapper: { one: 1, other: 2 },
  number: e,
  keysLength: n
}), Qn = (e, n) => K({
  langCode: "hr-HR",
  mapper: { one: 1, few: 2, other: 3 },
  number: e,
  keysLength: n
}), Xn = (e, n) => K({
  langCode: "cs-CZ",
  mapper: { one: 1, few: 2, other: 3 },
  number: e,
  keysLength: n
}), q = () => 0, Zn = {
  ar: Gn,
  cs: Xn,
  hr: Qn,
  id: q,
  is: Kn,
  ja: q,
  ko: q,
  lt: me,
  pl: Jn,
  ro: Yn,
  ru: me,
  uk: me,
  th: q,
  vi: q,
  zh: q,
  "zh-TW": q
}, er = "en";
function tr({ locale: e, messages: n, pluralRules: t }) {
  (!z(e) || !z(n)) && console.warn("i18n required locale and messages");
  const o = M(
    () => z(n)[z(e) || er] || {}
  ), r = (a, s) => sn(o.value[a] || a, s) || a, i = {
    t: r,
    tc: (a, s, l) => {
      var u;
      const d = (o.value[a] || a).split("|").map((p) => p.trim()), g = ((u = z(t)) == null ? void 0 : u[z(e)]) ?? qn;
      return r(
        d[g(s, d.length)] ?? d[0],
        l
      );
    }
  };
  return de(ln, i), i;
}
const nr = /* @__PURE__ */ ye({
  __name: "SetupProvider",
  props: {
    config: {}
  },
  setup(e) {
    const n = e;
    return Wn(n.config.payload.deviceStyleConfig), tr({
      locale: M(() => n.config.i18n.locale),
      messages: M(() => n.config.i18n.messages),
      pluralRules: M(() => n.config.i18n.pluralRules)
    }), (t, o) => Ft(t.$slots, "default");
  }
});
var De;
(function(e) {
  e.ApplyDiscount = "apply-discount", e.Dismiss = "dismiss", e.Engage = "engage", e.Hide = "hide", e.NoAction = "no-action", e.Fallback = "none", e.GenericLinkClick = "generic-link-click", e.LoadScript = "load-script", e.OpenBookingEngine = "open-be", e.OpenUri = "open-uri", e.PredictiveAudience = "predictive-audience", e.SendForm = "send-form", e.SendSaveSearch = "send-save-search", e.SendSiteContact = "send-site-contact", e.SendSubscribe = "send-subscribe", e.Show = "show", e.Login = "login", e.TranslateDocumentBody = "translate-document-body";
})(De || (De = {}));
var Ve;
(function(e) {
  e.Resend = "resend", e.Signup = "signup", e.Signin = "signin", e.Validation = "validation";
})(Ve || (Ve = {}));
var Ue;
(function(e) {
  e.Arabic = "ar", e.Basque = "eu", e.Bulgarian = "bg", e.Catalan = "ca", e.Chinese = "zh", e.ChineseTraditional = "zh-TW", e.Croatian = "hr", e.Czech = "cs", e.Danish = "da", e.Deutsch = "de", e.Dutch = "nl", e.English = "en", e.Estonian = "et", e.Finnish = "fi", e.French = "fr", e.Greek = "el", e.Hebrew = "he", e.Hungarian = "hu", e.Icelandic = "is", e.Indonesian = "id", e.Italian = "it", e.Japanese = "ja", e.Korean = "ko", e.Lithuanian = "lt", e.Norwegian = "no", e.Polish = "pl", e.Portuguese = "pt", e.Romanian = "ro", e.Russian = "ru", e.Slovenian = "sl", e.Spanish = "es", e.Swedish = "sv", e.Thai = "th", e.Turkish = "tr", e.Ukrainian = "uk", e.Vietnamese = "vi";
})(Ue || (Ue = {}));
var We;
(function(e) {
  e.Timing = "timing", e.Oraculo = "oraculo", e.VisitorProfile = "visitorProfile", e.VisitorBehaviour = "visitorBehaviour", e.Search = "search", e.TravelParty = "travelParty", e.DataVariables = "dataVariables", e.Demand = "demand", e.Integrations = "integrations";
})(We || (We = {}));
var qe;
(function(e) {
  e.Exclude = "exclude", e.Include = "include";
})(qe || (qe = {}));
var Ge;
(function(e) {
  e.Any = "any", e.Is = "is", e.Are = "are", e.IsBetween = "isBetween", e.AreBetween = "areBetween", e.IsLower = "isLower", e.AreLower = "areLower", e.IsHigher = "isHigher", e.IsGreater = "isGreater", e.AreGreater = "areGreater", e.IsBefore = "isBefore", e.AreBefore = "areBefore", e.IsAfter = "isAfter", e.AreAfter = "areAfter", e.Contain = "contain";
})(Ge || (Ge = {}));
var Ye;
(function(e) {
  e.Is = "is", e.IsNot = "isNot", e.AnyValue = "anyValue", e.NotAnyValue = "notAnyValue", e.Lower = "lower", e.Greater = "greater", e.Contains = "contains", e.NotContains = "notContains";
})(Ye || (Ye = {}));
var Je;
(function(e) {
  e.Registered = "registered", e.NonRegistered = "non_registered", e.RegisteredAndLogged = "registered", e.NotRegisteredAndNotLogged = "non_registered_nor_logged", e.RegisteredOrLogged = "registered_all", e.RegisteredAndNotLogged = "registered_non_logged", e.NotLogged = "non_registered";
})(Je || (Je = {}));
var Ke;
(function(e) {
  e.Logged = "logged", e.NonLogged = "nonLogged";
})(Ke || (Ke = {}));
var Qe;
(function(e) {
  e.Any = "any", e.First = "first", e.All = "all", e.Search = "search", e.Booked = "booked", e.Custom = "custom";
})(Qe || (Qe = {}));
var Xe;
(function(e) {
  e.Colors = "colors", e.Fonts = "fonts", e.Button = "button", e.Background = "background", e.Overlay = "overlay";
})(Xe || (Xe = {}));
var Ze;
(function(e) {
  e.None = "none", e.Uppercase = "uppercase", e.Lowercase = "lowercase", e.Titlecase = "titlecase";
})(Ze || (Ze = {}));
var et;
(function(e) {
  e.Google = "google", e.File = "file", e.Regular = "regular";
})(et || (et = {}));
var tt;
(function(e) {
  e.Custom = "custom", e.Square = "square", e.Medium = "medium", e.Rounded = "rounded";
})(tt || (tt = {}));
var nt;
(function(e) {
  e.Percentage = "%", e.Pixels = "px", e.Rem = "rem", e.Em = "em";
})(nt || (nt = {}));
var rt;
(function(e) {
  e.Solid = "solid", e.Outline = "outline";
})(rt || (rt = {}));
var ot;
(function(e) {
  e.Url = "url", e.DefaultText = "default_text", e.CustomText = "custom_text", e.NotLinked = "not_linked", e.CustomUrl = "custom_url";
})(ot || (ot = {}));
var V;
(function(e) {
  e.NowViewing = "nowViewing", e.TodayViewed = "todayViewed", e.BookedToday = "bookedToday", e.LastReservation = "lastReservation", e.DiscountToday = "discountToday", e.TodaySpecialOffer = "todaySpecialOffer";
})(V || (V = {}));
var at;
(function(e) {
  e.ApplyPromoCode = "apply_promo_code", e.OpenUrl = "open_url", e.OpenMailClient = "open_mail_client", e.CallPhoneNumber = "call_phone_number", e.CloseTool = "close_tool", e.EmailCapture = "email_capture", e.SavedSearch = "saved_search", e.GoMainStep = "go_main_step", e.SendForm = "form", e.OpenBookingEngine = "send_to_be", e.Submit = "submit", e.LastSearch = "send_to_last_search";
})(at || (at = {}));
var it;
(function(e) {
  e.Default = "default", e.Coupon = "coupon", e.Rate = "rate", e.Corporative = "corpo", e.Group = "group";
})(it || (it = {}));
var st;
(function(e) {
  e.Note = "note", e.Layer = "layer", e.Exit = "exit", e.Inliner = "inliner";
})(st || (st = {}));
var lt;
(function(e) {
  e.Success = "success", e.Failure = "failure", e.Main = "main";
})(lt || (lt = {}));
var ct;
(function(e) {
  e.LoginSignin = "login-signin", e.LoginRegister = "login-register", e.LoginSuccess = "login-success";
})(ct || (ct = {}));
var ut;
(function(e) {
  e.Activity = "activity", e.Button = "button", e.Countdown = "countdown", e.EmailCapture = "emailCapture", e.Form = "form", e.Heading = "heading", e.ImageWithBehaviour = "imageWithBehaviour", e.Icon = "icon", e.Paragraph = "paragraph", e.Perks = "perks", e.SavedSearch = "savedSearch", e.Spacer = "spacer", e.Login = "login";
})(ut || (ut = {}));
var Y;
(function(e) {
  e.None = "none", e.WebExclusive = "web_exclusive", e.SubjectToAvailibity = "subject_to_availability", e.OnlyForSpecificRates = "only_for_specific_rates", e.OnlyForRegisterdUsers = "only_for_registered_users";
})(Y || (Y = {}));
var dt;
(function(e) {
  e.Bullets = "bullets", e.Highlights = "highlights";
})(dt || (dt = {}));
var gt;
(function(e) {
  e.None = "none", e.Solid = "solid", e.Outline = "outline";
})(gt || (gt = {}));
var ft;
(function(e) {
  e.Normal = "normal", e.Compact = "compact";
})(ft || (ft = {}));
var ht;
(function(e) {
  e.Date = "date", e.Time = "time";
})(ht || (ht = {}));
var mt;
(function(e) {
  e.Visitor = "visitor", e.Hotel = "hotel";
})(mt || (mt = {}));
var vt;
(function(e) {
  e.Out = "out", e.Inside = "inside";
})(vt || (vt = {}));
var pt;
(function(e) {
  e.Single = "single", e.Multiple = "multiple";
})(pt || (pt = {}));
var bt;
(function(e) {
  e.ShortText = "shortText", e.Email = "email", e.Phone = "phone", e.Date = "date", e.LongText = "longText", e.DropDown = "dropdown", e.Selection = "selection";
})(bt || (bt = {}));
var wt;
(function(e) {
  e.Top = "T", e.Bottom = "B", e.Left = "L", e.Right = "R", e.UpperLeft = "UL", e.UpperRight = "UR", e.UpperMidLeft = "UML", e.UpperMidRight = "UMR", e.LowerMidLeft = "LML", e.LowerMidRight = "LMR", e.LowerLeft = "LL", e.LowerRight = "LR";
})(wt || (wt = {}));
var yt;
(function(e) {
  e.Mobile = "mobile", e.Desktop = "desktop";
})(yt || (yt = {}));
var Ct;
(function(e) {
  e.EveryPage = "on_every_page", e.OncePerVisit = "once_per_visit", e.OncePerVisitor = "once_per_visitor", e.OncePerProperty = "once_per_property", e.OncePerBrand = "once_per_brand";
})(Ct || (Ct = {}));
var St;
(function(e) {
  e.Load = "load", e.Scroll = "scroll", e.Idle = "idle";
})(St || (St = {}));
var Mt;
(function(e) {
  e.Regular = "regular", e.Compact = "compact";
})(Mt || (Mt = {}));
var xt;
(function(e) {
  e.Single = "single", e.Multi = "multi";
})(xt || (xt = {}));
var _t;
(function(e) {
  e.Bar = "bar", e.Circular = "circular", e.CustomImage = "custom-image", e.Fullscreen = "full-screen", e.FullscreenMini = "full-screen-mini", e.LowerNotification = "lower-notification", e.NotificationTab = "notification-tab", e.Sidebar = "sidebar", e.SideGradient = "side-gradient", e.SlideIn = "slide-in", e.Square = "square", e.SquareImage = "square-image", e.Sticky = "sticky", e.StickyImage = "sticky-image";
})(_t || (_t = {}));
var At;
(function(e) {
  e.Left = "left", e.Center = "center", e.Right = "right";
})(At || (At = {}));
V.NowViewing + "", V.TodayViewed + "", V.BookedToday + "", V.LastReservation + "", V.DiscountToday + "", V.TodaySpecialOffer + "";
Y.None + "", Y.SubjectToAvailibity + "", Y.WebExclusive + "", Y.OnlyForRegisterdUsers + "", Y.OnlyForSpecificRates + "";
function Pr({
  enabled: e,
  delay: n,
  callback: t
}) {
  const o = setTimeout(() => {
    e && n > 0 && t();
  }, n * 1e3), r = () => clearTimeout(o);
  return Nt(r), {
    clear: r
  };
}
const rr = 10, or = 100;
function Dr(e, n) {
  const t = x(0), { lengthY: o, direction: r } = hn(
    e,
    {
      threshold: rr,
      onSwipe() {
        r.value === "down" && (t.value = o.value);
      },
      onSwipeEnd() {
        if (r.value === "down" && Math.abs(o.value) > or) {
          n.onEnd();
          return;
        }
        t.value = 0;
      }
    }
  );
  return { distanceY: t };
}
var ar = { "": ["<em>", "</em>"], _: ["<strong>", "</strong>"], "*": ["<strong>", "</strong>"], "~": ["<s>", "</s>"], "\n": ["<br />"], " ": ["<br />"], "-": ["<hr />"] };
function kt(e) {
  return e.replace(RegExp("^" + (e.match(/^(\t| )+/) || "")[0], "gm"), "");
}
function ie(e) {
  return (e + "").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function we(e, n) {
  var t, o, r, i, a, s = /((?:^|\n+)(?:\n---+|\* \*(?: \*)+)\n)|(?:^``` *(\w*)\n([\s\S]*?)\n```$)|((?:(?:^|\n+)(?:\t|  {2,}).+)+\n*)|((?:(?:^|\n)([>*+-]|\d+\.)\s+.*)+)|(?:!\[([^\]]*?)\]\(([^)]+?)\))|(\[)|(\](?:\(([^)]+?)\))?)|(?:(?:^|\n+)([^\s].*)\n(-{3,}|={3,})(?:\n+|$))|(?:(?:^|\n+)(#{1,6})\s*(.+)(?:\n+|$))|(?:`([^`].*?)`)|(  \n\n*|\n{2,}|__|\*\*|[_*]|~~)/gm, l = [], u = "", d = n || {}, g = 0;
  function p(w) {
    var y = ar[w[1] || ""], A = l[l.length - 1] == w;
    return y ? y[1] ? (A ? l.pop() : l.push(w), y[0 | A]) : y[0] : w;
  }
  function h() {
    for (var w = ""; l.length; ) w += p(l[l.length - 1]);
    return w;
  }
  for (e = e.replace(/^\[(.+?)\]:\s*(.+)$/gm, function(w, y, A) {
    return d[y.toLowerCase()] = A, "";
  }).replace(/^\n+|\n+$/g, ""); r = s.exec(e); ) o = e.substring(g, r.index), g = s.lastIndex, t = r[0], o.match(/[^\\](\\\\)*\\$/) || ((a = r[3] || r[4]) ? t = '<pre class="code ' + (r[4] ? "poetry" : r[2].toLowerCase()) + '"><code' + (r[2] ? ' class="language-' + r[2].toLowerCase() + '"' : "") + ">" + kt(ie(a).replace(/^\n+|\n+$/g, "")) + "</code></pre>" : (a = r[6]) ? (a.match(/\./) && (r[5] = r[5].replace(/^\d+/gm, "")), i = we(kt(r[5].replace(/^\s*[>*+.-]/gm, ""))), a == ">" ? a = "blockquote" : (a = a.match(/\./) ? "ol" : "ul", i = i.replace(/^(.*)(\n|$)/gm, "<li>$1</li>")), t = "<" + a + ">" + i + "</" + a + ">") : r[8] ? t = '<img src="' + ie(r[8]) + '" alt="' + ie(r[7]) + '">' : r[10] ? (u = u.replace("<a>", '<a href="' + ie(r[11] || d[o.toLowerCase()]) + '">'), t = h() + "</a>") : r[9] ? t = "<a>" : r[12] || r[14] ? t = "<" + (a = "h" + (r[14] ? r[14].length : r[13] > "=" ? 1 : 2)) + ">" + we(r[12] || r[15], d) + "</" + a + ">" : r[16] ? t = "<code>" + ie(r[16]) + "</code>" : (r[17] || r[1]) && (t = p(r[17] || "--"))), u += o, u += t;
  return (u + e.substring(g) + h()).replace(/^\n+|\n+$/g, "");
}
const ir = (e, n) => {
  const t = "http://www.w3.org/2000/svg", r = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M4.9 4.16l.867 1.223c-2.629 1.866-3.255 5.11-1.562 7.614a.75.75 0 01.09.657l-.669 2.006 2.635-.56a.75.75 0 01.48.057 7.527 7.527 0 004.046.703.75.75 0 01.156 1.492 9.027 9.027 0 01-4.615-.733l-3.672.781a.75.75 0 01-.868-.97l.97-2.911c-1.917-3.175-1-7.13 2.141-9.36zm11.35 8.55a.75.75 0 01.207 1.04l-.889 1.333H17.5a.75.75 0 01.624 1.166l-1.667 2.5a.75.75 0 01-1.248-.832l.89-1.334h-1.932a.75.75 0 01-.624-1.166l1.666-2.5a.75.75 0 011.04-.208z" clip-rule="evenodd"/>
  <path d="M4.9 4.16l.867 1.223a6.997 6.997 0 011.564-.831L4.9 4.16z"/>
  <path d="M15.69 4.601c-2.977-2.54-7.576-2.72-10.79-.441l2.431.392c2.457-.934 5.387-.515 7.386 1.19 1.486 1.267 2.161 2.988 2.028 4.658a.75.75 0 101.495.12c.173-2.169-.713-4.352-2.55-5.919z"/>
</svg>
`, "image/svg+xml").firstChild;
  if (e.title) {
    const a = document.createElementNS(t, "title");
    a.textContent = e.title, r.appendChild(a);
  }
  const i = Array.from((r == null ? void 0 : r.attributes) ?? []).reduce((a, s) => ({
    ...a,
    [s.name]: s.value
  }));
  return _(
    "svg",
    {
      ...i,
      ...n.attrs,
      role: "img",
      innerHTML: r.innerHTML
    }
  );
}, sr = (e, n) => {
  const t = "http://www.w3.org/2000/svg", r = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path d="M15.69 4.601c-2.977-2.54-7.576-2.72-10.79-.441-3.142 2.23-4.06 6.184-2.141 9.359l-.97 2.91a.75.75 0 00.867.971l3.671-.78a9.1 9.1 0 006.415.362.75.75 0 00-.45-1.43c-1.777.558-3.795.457-5.548-.393a.75.75 0 00-.483-.06l-2.635.561.669-2.006a.75.75 0 00-.09-.657c-1.693-2.504-1.067-5.748 1.562-7.614 2.177-1.544 5.141-1.718 7.487-.59l2.437-.192z"/>
  <path d="M14.717 5.742a5.912 5.912 0 011.567 2.053l-.593-3.194-2.437.192a6.778 6.778 0 011.463.95z"/>
  <path d="M18.248 10.408c.135-2.131-.751-4.267-2.557-5.807l.593 3.194c.366.807.521 1.668.468 2.518a.75.75 0 101.497.095zM16.583 13.333a.75.75 0 10-1.5 0v2.5a.75.75 0 001.5 0v-2.5zM16.583 18.333a.75.75 0 10-1.5 0v.009a.75.75 0 001.5 0v-.009z"/>
</svg>
`, "image/svg+xml").firstChild;
  if (e.title) {
    const a = document.createElementNS(t, "title");
    a.textContent = e.title, r.appendChild(a);
  }
  const i = Array.from((r == null ? void 0 : r.attributes) ?? []).reduce((a, s) => ({
    ...a,
    [s.name]: s.value
  }));
  return _(
    "svg",
    {
      ...i,
      ...n.attrs,
      role: "img",
      innerHTML: r.innerHTML
    }
  );
}, lr = (e, n) => {
  const t = "http://www.w3.org/2000/svg", r = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M5.767 5.383c2.663-1.888 6.503-1.728 8.95.36zm8.95.36c1.23 1.049 1.904 2.408 2.025 3.788a.75.75 0 101.494-.132c-.157-1.785-1.027-3.502-2.545-4.798-2.978-2.54-7.577-2.72-10.792-.441-3.141 2.23-4.058 6.184-2.14 9.359l-.97 2.91a.75.75 0 00.867.971l3.671-.78a9.1 9.1 0 006.415.362.75.75 0 10-.45-1.43c-1.777.558-3.795.457-5.548-.393a.75.75 0 00-.483-.06l-2.635.561.669-2.006a.75.75 0 00-.09-.657c-1.693-2.504-1.067-5.748 1.562-7.614m9.605 6.414a2.4 2.4 0 011.565.217l.003.002a2.42 2.42 0 01-1.104 4.567.75.75 0 11-.005-1.5.919.919 0 00.42-1.735.9.9 0 00-1.095.22.75.75 0 11-1.145-.968 2.4 2.4 0 011.36-.803zm.461 5.786a.75.75 0 01.75.75v.009a.75.75 0 11-1.5 0v-.009a.75.75 0 01.75-.75z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (e.title) {
    const a = document.createElementNS(t, "title");
    a.textContent = e.title, r.appendChild(a);
  }
  const i = Array.from((r == null ? void 0 : r.attributes) ?? []).reduce((a, s) => ({
    ...a,
    [s.name]: s.value
  }));
  return _(
    "svg",
    {
      ...i,
      ...n.attrs,
      role: "img",
      innerHTML: r.innerHTML
    }
  );
}, cr = (e, n) => {
  const t = "http://www.w3.org/2000/svg", r = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M4.167 4.917a.917.917 0 00-.846.562L10 9.932l6.679-4.453a.917.917 0 00-.846-.562H4.167zM16.75 7.235l-6.334 4.222a.75.75 0 01-.832 0L3.25 7.235v6.932a.917.917 0 00.917.916h11.666a.917.917 0 00.917-.916V7.235zM2.458 4.125a2.417 2.417 0 011.709-.708h11.666a2.417 2.417 0 012.417 2.416v8.334a2.417 2.417 0 01-2.417 2.416H4.167a2.417 2.417 0 01-2.417-2.416V5.833c0-.64.255-1.255.708-1.708z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (e.title) {
    const a = document.createElementNS(t, "title");
    a.textContent = e.title, r.appendChild(a);
  }
  const i = Array.from((r == null ? void 0 : r.attributes) ?? []).reduce((a, s) => ({
    ...a,
    [s.name]: s.value
  }));
  return _(
    "svg",
    {
      ...i,
      ...n.attrs,
      role: "img",
      innerHTML: r.innerHTML
    }
  );
}, ur = (e, n) => {
  const t = "http://www.w3.org/2000/svg", r = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M5.833 4.917a1.75 1.75 0 00-1.75 1.75v9.022l2.053-2.053a.75.75 0 01.53-.22h7.5a1.75 1.75 0 001.75-1.75v-5a1.75 1.75 0 00-1.75-1.75H5.834zm-2.298-.548a3.25 3.25 0 012.298-.952h8.334a3.25 3.25 0 013.25 3.25v5a3.25 3.25 0 01-3.25 3.25h-7.19L3.864 18.03a.75.75 0 01-1.28-.53V6.667c0-.862.342-1.689.951-2.298zM7.167 7.5a.75.75 0 01.75-.75h.008a.75.75 0 010 1.5h-.008a.75.75 0 01-.75-.75zm4.166 0a.75.75 0 01.75-.75h.009a.75.75 0 010 1.5h-.009a.75.75 0 01-.75-.75zm-3.941 2.798a.75.75 0 011.06.01 2.167 2.167 0 003.096 0 .75.75 0 011.071 1.05 3.666 3.666 0 01-5.238 0 .75.75 0 01.01-1.06z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (e.title) {
    const a = document.createElementNS(t, "title");
    a.textContent = e.title, r.appendChild(a);
  }
  const i = Array.from((r == null ? void 0 : r.attributes) ?? []).reduce((a, s) => ({
    ...a,
    [s.name]: s.value
  }));
  return _(
    "svg",
    {
      ...i,
      ...n.attrs,
      role: "img",
      innerHTML: r.innerHTML
    }
  );
}, dr = (e, n) => {
  const t = "http://www.w3.org/2000/svg", r = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M5.833 4.917a1.75 1.75 0 00-1.75 1.75v9.022l2.053-2.053a.75.75 0 01.53-.22h7.5a1.75 1.75 0 001.75-1.75v-5a1.75 1.75 0 00-1.75-1.75H5.834zm-2.298-.548a3.25 3.25 0 012.298-.952h8.334a3.25 3.25 0 013.25 3.25v5a3.25 3.25 0 01-3.25 3.25h-7.19L3.864 18.03a.75.75 0 01-1.28-.53V6.667c0-.862.342-1.689.951-2.298zm3.132 4.048a.75.75 0 01.75.75v.008a.75.75 0 01-1.5 0v-.008a.75.75 0 01.75-.75zm3.333 0a.75.75 0 01.75.75v.008a.75.75 0 11-1.5 0v-.008a.75.75 0 01.75-.75zm3.333 0a.75.75 0 01.75.75v.008a.75.75 0 01-1.5 0v-.008a.75.75 0 01.75-.75z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (e.title) {
    const a = document.createElementNS(t, "title");
    a.textContent = e.title, r.appendChild(a);
  }
  const i = Array.from((r == null ? void 0 : r.attributes) ?? []).reduce((a, s) => ({
    ...a,
    [s.name]: s.value
  }));
  return _(
    "svg",
    {
      ...i,
      ...n.attrs,
      role: "img",
      innerHTML: r.innerHTML
    }
  );
}, gr = (e, n) => {
  const t = "http://www.w3.org/2000/svg", r = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M9.167 3.25a.083.083 0 00-.084.083v5a.083.083 0 00.084.084H15a.75.75 0 01.53.22l1.22 1.219V3.333a.083.083 0 00-.083-.083h-7.5zm-1.12-1.036c.297-.297.7-.464 1.12-.464h7.5a1.584 1.584 0 011.583 1.583v8.334a.75.75 0 01-1.28.53l-2.28-2.28H9.166a1.583 1.583 0 01-1.584-1.584v-5c0-.42.167-.822.464-1.12zm-4.714 6.87a.083.083 0 00-.083.083v6.522l1.22-1.22A.75.75 0 015 14.25h5.833a.084.084 0 00.084-.083V12.5a.75.75 0 011.5 0v1.667a1.583 1.583 0 01-1.584 1.583H5.311l-2.28 2.28a.75.75 0 01-1.281-.53V9.167a1.583 1.583 0 011.583-1.584H5a.75.75 0 010 1.5H3.333z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (e.title) {
    const a = document.createElementNS(t, "title");
    a.textContent = e.title, r.appendChild(a);
  }
  const i = Array.from((r == null ? void 0 : r.attributes) ?? []).reduce((a, s) => ({
    ...a,
    [s.name]: s.value
  }));
  return _(
    "svg",
    {
      ...i,
      ...n.attrs,
      role: "img",
      innerHTML: r.innerHTML
    }
  );
}, fr = (e, n) => {
  const t = "http://www.w3.org/2000/svg", r = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M6.843 2.378a8.25 8.25 0 116.314 15.244A8.25 8.25 0 016.843 2.378zM10 3.25a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zM6.75 7.5a.75.75 0 01.75-.75h.008a.75.75 0 110 1.5H7.5a.75.75 0 01-.75-.75zm5 0a.75.75 0 01.75-.75h.008a.75.75 0 010 1.5H12.5a.75.75 0 01-.75-.75zm-5.614 2.803a.75.75 0 01.53-.22h6.667a.75.75 0 01.75.75 4.084 4.084 0 01-8.166 0 .75.75 0 01.22-.53zm1.392 1.28a2.583 2.583 0 004.944 0H7.528z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (e.title) {
    const a = document.createElementNS(t, "title");
    a.textContent = e.title, r.appendChild(a);
  }
  const i = Array.from((r == null ? void 0 : r.attributes) ?? []).reduce((a, s) => ({
    ...a,
    [s.name]: s.value
  }));
  return _(
    "svg",
    {
      ...i,
      ...n.attrs,
      role: "img",
      innerHTML: r.innerHTML
    }
  );
}, hr = (e, n) => {
  const t = "http://www.w3.org/2000/svg", r = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M10 3.25a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zm-3.157-.872a8.25 8.25 0 116.314 15.244A8.25 8.25 0 016.843 2.378zm.24 4.58c.66 0 1.532.26 1.921 1.04a.75.75 0 11-1.341.67c-.028-.053-.197-.21-.58-.21-.382 0-.552.156-.579.21a.75.75 0 11-1.341-.67c.39-.78 1.261-1.04 1.92-1.04zm5.834 0c.659 0 1.53.26 1.92 1.04a.75.75 0 11-1.341.67c-.027-.053-.197-.21-.58-.21-.382 0-.551.156-.579.21a.75.75 0 01-1.341-.67c.39-.78 1.261-1.04 1.92-1.04zm-5.525 5.006a.75.75 0 011.06.011 2.165 2.165 0 003.096 0 .75.75 0 111.071 1.05 3.666 3.666 0 01-5.238 0 .75.75 0 01.01-1.06z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (e.title) {
    const a = document.createElementNS(t, "title");
    a.textContent = e.title, r.appendChild(a);
  }
  const i = Array.from((r == null ? void 0 : r.attributes) ?? []).reduce((a, s) => ({
    ...a,
    [s.name]: s.value
  }));
  return _(
    "svg",
    {
      ...i,
      ...n.attrs,
      role: "img",
      innerHTML: r.innerHTML
    }
  );
}, mr = (e, n) => {
  const t = "http://www.w3.org/2000/svg", r = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M18.03 1.97a.75.75 0 01.175.785l-5.416 15a1.208 1.208 0 01-2.214.072l-2.8-5.601-5.602-2.8a1.208 1.208 0 01.072-2.215l15-5.416a.75.75 0 01.785.175zm-8.784 9.845l2.377 4.753 4.03-11.16-6.407 6.407zm5.346-7.467l-11.16 4.03 4.753 2.376 6.407-6.406z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (e.title) {
    const a = document.createElementNS(t, "title");
    a.textContent = e.title, r.appendChild(a);
  }
  const i = Array.from((r == null ? void 0 : r.attributes) ?? []).reduce((a, s) => ({
    ...a,
    [s.name]: s.value
  }));
  return _(
    "svg",
    {
      ...i,
      ...n.attrs,
      role: "img",
      innerHTML: r.innerHTML
    }
  );
}, vr = (e, n) => {
  const t = "http://www.w3.org/2000/svg", r = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M9.583 4.917c-.608 0-1.173.208-1.574.552-.397.34-.592.774-.592 1.198a.75.75 0 11-1.5 0c0-.903.419-1.74 1.116-2.337.693-.595 1.612-.913 2.55-.913h.834c.938 0 1.857.318 2.55.913.692.592 1.11 1.421 1.116 2.316a3.25 3.25 0 01-2.126 3.214c-.321.16-.637.472-.87.938a3.45 3.45 0 00-.338 1.67.75.75 0 11-1.498.064 4.948 4.948 0 01.494-2.405c.361-.722.912-1.315 1.603-1.64a.744.744 0 01.07-.028 1.75 1.75 0 001.165-1.792c0-.424-.195-.858-.592-1.198-.4-.344-.966-.552-1.574-.552h-.834zM10 15.084a.75.75 0 01.75.75v.008a.75.75 0 01-1.5 0v-.008a.75.75 0 01.75-.75z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (e.title) {
    const a = document.createElementNS(t, "title");
    a.textContent = e.title, r.appendChild(a);
  }
  const i = Array.from((r == null ? void 0 : r.attributes) ?? []).reduce((a, s) => ({
    ...a,
    [s.name]: s.value
  }));
  return _(
    "svg",
    {
      ...i,
      ...n.attrs,
      role: "img",
      innerHTML: r.innerHTML
    }
  );
}, pr = (e, n) => {
  const t = "http://www.w3.org/2000/svg", r = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M16.186 3.32a.916.916 0 00-.999.199l-1.609 1.61a5.005 5.005 0 011.296 1.297l1.61-1.611a.917.917 0 00-.298-1.495zm-.632 4.547a5.004 5.004 0 01-1.097 4.745l-.014.015-.147.153-.011.012-1.556 1.556a2.15 2.15 0 00-.626 1.37l-.005.166v.765c0 .472-.188.923-.519 1.255a1.175 1.175 0 01-1.563.09l-.058-.05a.74.74 0 01-.042-.039l-7.82-7.82a1.178 1.178 0 01-.256-1.281c.059-.142.146-.272.255-.381m0 0a1.775 1.775 0 011.097-.513l.116-.006a.746.746 0 01.043-.001h.777c.52 0 1.02-.189 1.412-.527l.121-.114 1.547-1.546.012-.012.133-.128.012-.01a5.004 5.004 0 014.773-1.119l1.988-1.989a2.416 2.416 0 113.419 3.417l-1.99 1.992m-7.17-1.2l-.122.115-1.55 1.55a.74.74 0 01-.018.018l-.14.13a3.656 3.656 0 01-2.426.922h-.596l7.065 7.064v-.595-.026l.007-.192a3.65 3.65 0 011.063-2.366l1.55-1.55.133-.14a3.504 3.504 0 00-.127-4.82M3.154 9.023s.001 0 0 0zm5.23-2.358a3.504 3.504 0 014.84.11m-9.89 6.64a.75.75 0 01.75.75 1.75 1.75 0 001.75 1.75.75.75 0 010 1.5 3.25 3.25 0 01-3.25-3.25.75.75 0 01.75-.75z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (e.title) {
    const a = document.createElementNS(t, "title");
    a.textContent = e.title, r.appendChild(a);
  }
  const i = Array.from((r == null ? void 0 : r.attributes) ?? []).reduce((a, s) => ({
    ...a,
    [s.name]: s.value
  }));
  return _(
    "svg",
    {
      ...i,
      ...n.attrs,
      role: "img",
      innerHTML: r.innerHTML
    }
  );
}, br = (e, n) => {
  const t = "http://www.w3.org/2000/svg", r = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M6.843 2.378a8.25 8.25 0 116.314 15.244A8.25 8.25 0 016.843 2.378zM10 3.25a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zM6.75 8.333a.75.75 0 01.75-.75h.008a.75.75 0 110 1.5H7.5a.75.75 0 01-.75-.75zm5 0a.75.75 0 01.75-.75h.008a.75.75 0 010 1.5H12.5a.75.75 0 01-.75-.75zm-4.358 3.631a.75.75 0 011.06.011 2.165 2.165 0 003.096 0 .75.75 0 111.071 1.05 3.666 3.666 0 01-5.238 0 .75.75 0 01.01-1.06z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (e.title) {
    const a = document.createElementNS(t, "title");
    a.textContent = e.title, r.appendChild(a);
  }
  const i = Array.from((r == null ? void 0 : r.attributes) ?? []).reduce((a, s) => ({
    ...a,
    [s.name]: s.value
  }));
  return _(
    "svg",
    {
      ...i,
      ...n.attrs,
      role: "img",
      innerHTML: r.innerHTML
    }
  );
}, wr = (e, n) => {
  const t = "http://www.w3.org/2000/svg", r = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 21" fill="currentColor">
  <path fill-rule="evenodd" d="M7.113 3.779a4.083 4.083 0 115.774 5.775 4.083 4.083 0 01-5.774-5.775zM10 4.083a2.583 2.583 0 100 5.167 2.583 2.583 0 000-5.167zm-1.667 10a2.584 2.584 0 00-2.583 2.583v1.667a.75.75 0 01-1.5 0v-1.667a4.083 4.083 0 014.083-4.083h.417a.75.75 0 010 1.5h-.417zm3.354-.76a2.618 2.618 0 013.316-.272 2.619 2.619 0 013.317.283 2.537 2.537 0 01-.005 3.632l-.001.002-2.789 2.734a.75.75 0 01-1.05 0l-2.795-2.746a2.537 2.537 0 01.007-3.634zm1.825.76c-.291 0-.572.113-.78.316a1.035 1.035 0 00-.004 1.484l.002.002 2.27 2.23 2.27-2.224a1.036 1.036 0 00.002-1.484 1.12 1.12 0 00-1.56-.005l-.001.002-.184.18a.75.75 0 01-1.052-.001l-.183-.181-.002-.001a1.119 1.119 0 00-.778-.318z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (e.title) {
    const a = document.createElementNS(t, "title");
    a.textContent = e.title, r.appendChild(a);
  }
  const i = Array.from((r == null ? void 0 : r.attributes) ?? []).reduce((a, s) => ({
    ...a,
    [s.name]: s.value
  }));
  return _(
    "svg",
    {
      ...i,
      ...n.attrs,
      role: "img",
      innerHTML: r.innerHTML
    }
  );
}, yr = (e, n) => {
  const t = "http://www.w3.org/2000/svg", r = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 21" fill="currentColor">
  <path fill-rule="evenodd" d="M7.113 3.779a4.083 4.083 0 115.774 5.775 4.083 4.083 0 01-5.774-5.775zM10 4.083a2.583 2.583 0 100 5.167 2.583 2.583 0 000-5.167zm-1.667 10a2.583 2.583 0 00-2.583 2.583v1.667a.75.75 0 01-1.5 0v-1.667a4.083 4.083 0 014.083-4.083h2.917a.75.75 0 010 1.5H8.333zm7.039-1.453a2.4 2.4 0 011.565.217l.003.002a2.42 2.42 0 01-1.104 4.567.75.75 0 11-.005-1.5.92.92 0 00.42-1.735.9.9 0 00-1.095.22.75.75 0 11-1.145-.968 2.4 2.4 0 011.36-.803zm.461 5.786a.75.75 0 01.75.75v.009a.75.75 0 01-1.5 0v-.009a.75.75 0 01.75-.75z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (e.title) {
    const a = document.createElementNS(t, "title");
    a.textContent = e.title, r.appendChild(a);
  }
  const i = Array.from((r == null ? void 0 : r.attributes) ?? []).reduce((a, s) => ({
    ...a,
    [s.name]: s.value
  }));
  return _(
    "svg",
    {
      ...i,
      ...n.attrs,
      role: "img",
      innerHTML: r.innerHTML
    }
  );
}, Cr = (e, n) => {
  const t = "http://www.w3.org/2000/svg", r = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 21" fill="currentColor">
  <path fill-rule="evenodd" d="M4.53 5.363c-.886.887-1.28 2.465-1.28 5.47 0 2.918.371 4.49 1.204 5.39a4.083 4.083 0 013.88-2.807h3.333a4.083 4.083 0 013.879 2.808c.833-.9 1.204-2.473 1.204-5.391 0-3.005-.394-4.583-1.28-5.47-.887-.886-2.465-1.28-5.47-1.28s-4.583.394-5.47 1.28zm9.684 11.708a2.584 2.584 0 00-2.547-2.155H8.333a2.583 2.583 0 00-2.547 2.155c.947.35 2.287.512 4.214.512 1.927 0 3.267-.162 4.214-.512zM3.47 4.303c1.363-1.364 3.535-1.72 6.53-1.72s5.167.356 6.53 1.72c1.364 1.363 1.72 3.535 1.72 6.53s-.356 5.167-1.72 6.53c-1.363 1.364-3.535 1.72-6.53 1.72s-5.167-.356-6.53-1.72C2.106 16 1.75 13.828 1.75 10.833s.356-5.167 1.72-6.53zm4.232 2.565a3.25 3.25 0 114.596 4.597 3.25 3.25 0 01-4.596-4.597zM10 7.416a1.75 1.75 0 100 3.5 1.75 1.75 0 000-3.5z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (e.title) {
    const a = document.createElementNS(t, "title");
    a.textContent = e.title, r.appendChild(a);
  }
  const i = Array.from((r == null ? void 0 : r.attributes) ?? []).reduce((a, s) => ({
    ...a,
    [s.name]: s.value
  }));
  return _(
    "svg",
    {
      ...i,
      ...n.attrs,
      role: "img",
      innerHTML: r.innerHTML
    }
  );
}, Dt = {
  MessageChatbotIcon: ur,
  BubbleBoltIcon: ir,
  BubbleExclamationIcon: sr,
  BubbleQuestionIcon: lr,
  MessagesIcon: gr,
  MoodHappyIcon: fr,
  MoodSmileBeamIcon: hr,
  SmileIcon: br,
  EnvelopeIcon: cr,
  MessageDotsIcon: dr,
  PaperPlaneIcon: mr,
  QuestionMarkIcon: vr,
  SchoolBellIcon: pr,
  UserHeartIcon: wr,
  UserQuestionIcon: yr,
  UserSquareRoundedIcon: Cr
}, Vr = Object.entries(Dt).map(([e, n]) => ({
  name: e,
  component: () => n
})), Ur = (e) => Dt[e] || null, Sr = Symbol("config"), Mr = Symbol("chatConnection");
var G = /* @__PURE__ */ ((e) => (e.USER = "user", e.ASSISTANT = "assistant", e.SYSTEM = "system", e))(G || {});
const xr = /* @__PURE__ */ ye({
  __name: "ConfigProvider",
  props: {
    config: {}
  },
  setup(e) {
    const n = e;
    de(Sr, n.config);
    const t = M(() => n.config.logger || console), o = M(() => (t.value.debug("THN: props.config", { ...n.config }), {
      ...n.config
    }));
    return (r, i) => Ft(r.$slots, "default", { config: o.value });
  }
}), Lt = () => {
  const e = Date.now().toString(36), n = Math.random().toString(36).substring(2, 10);
  return e + n;
};
function le(e) {
  return Ht() ? (Et(e), !0) : !1;
}
function fe(e) {
  return typeof e == "function" ? e() : z(e);
}
const Z = typeof window < "u" && typeof document < "u", _r = typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope, Ar = Object.prototype.toString, kr = (e) => Ar.call(e) === "[object Object]", Vt = () => {
};
function Lr(e) {
  return It();
}
function Tr(...e) {
  if (e.length !== 1)
    return Gt(...e);
  const n = e[0];
  return typeof n == "function" ? Yt(Jt(() => ({ get: n, set: Vt }))) : x(n);
}
function Hr(e, n = !0, t) {
  Lr() ? zt(e, t) : n ? e() : qt(e);
}
function Er(e, n = 1e3, t = {}) {
  const {
    immediate: o = !0,
    immediateCallback: r = !1
  } = t;
  let i = null;
  const a = x(!1);
  function s() {
    i && (clearInterval(i), i = null);
  }
  function l() {
    a.value = !1, s();
  }
  function u() {
    const d = fe(n);
    d <= 0 || (a.value = !0, r && e(), s(), i = setInterval(e, d));
  }
  if (o && Z && u(), Kt(n) || typeof n == "function") {
    const d = J(n, () => {
      a.value && Z && u();
    });
    le(d);
  }
  return le(l), {
    isActive: a,
    pause: l,
    resume: u
  };
}
function Fr(e) {
  var n;
  const t = fe(e);
  return (n = t == null ? void 0 : t.$el) != null ? n : t;
}
const Se = Z ? window : void 0;
function Ut(...e) {
  let n, t, o, r;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([t, o, r] = e, n = Se) : [n, t, o, r] = e, !n)
    return Vt;
  Array.isArray(t) || (t = [t]), Array.isArray(o) || (o = [o]);
  const i = [], a = () => {
    i.forEach((d) => d()), i.length = 0;
  }, s = (d, g, p, h) => (d.addEventListener(g, p, h), () => d.removeEventListener(g, p, h)), l = J(
    () => [Fr(n), fe(r)],
    ([d, g]) => {
      if (a(), !d)
        return;
      const p = kr(g) ? { ...g } : g;
      i.push(
        ...t.flatMap((h) => o.map((w) => s(d, h, w, p)))
      );
    },
    { immediate: !0, flush: "post" }
  ), u = () => {
    l(), a();
  };
  return le(u), u;
}
function Nr() {
  const e = x(!1), n = It();
  return n && zt(() => {
    e.value = !0;
  }, n), e;
}
function zr(e) {
  const n = Nr();
  return M(() => (n.value, !!e()));
}
function Ir(e, n = {}) {
  const { window: t = Se } = n, o = zr(() => t && "matchMedia" in t && typeof t.matchMedia == "function");
  let r;
  const i = x(!1), a = (u) => {
    i.value = u.matches;
  }, s = () => {
    r && ("removeEventListener" in r ? r.removeEventListener("change", a) : r.removeListener(a));
  }, l = Qt(() => {
    o.value && (s(), r = t.matchMedia(fe(e)), "addEventListener" in r ? r.addEventListener("change", a) : r.addListener(a), i.value = r.matches);
  });
  return le(() => {
    l(), s(), r = void 0;
  }), i;
}
const Tt = "ping";
function ve(e) {
  return e === !0 ? {} : e;
}
function Rr(e, n = {}) {
  const {
    onConnected: t,
    onDisconnected: o,
    onError: r,
    onMessage: i,
    immediate: a = !0,
    autoClose: s = !0,
    protocols: l = []
  } = n, u = x(null), d = x("CLOSED"), g = x(), p = Tr(e);
  let h, w, y = !1, A = 0, E = [], B;
  const U = () => {
    if (E.length && g.value && d.value === "OPEN") {
      for (const m of E)
        g.value.send(m);
      E = [];
    }
  }, k = () => {
    clearTimeout(B), B = void 0;
  }, F = (m = 1e3, C) => {
    !Z || !g.value || (y = !0, k(), h == null || h(), g.value.close(m, C), g.value = void 0);
  }, Q = (m, C = !0) => !g.value || d.value !== "OPEN" ? (C && E.push(m), !1) : (U(), g.value.send(m), !0), R = () => {
    if (y || typeof p.value > "u")
      return;
    const m = new WebSocket(p.value, l);
    g.value = m, d.value = "CONNECTING", m.onopen = () => {
      d.value = "OPEN", t == null || t(m), w == null || w(), U();
    }, m.onclose = (C) => {
      if (d.value = "CLOSED", o == null || o(m, C), !y && n.autoReconnect) {
        const {
          retries: L = -1,
          delay: X = 1e3,
          onFailed: f
        } = ve(n.autoReconnect);
        A += 1, typeof L == "number" && (L < 0 || A < L) || typeof L == "function" && L() ? setTimeout(R, X) : f == null || f();
      }
    }, m.onerror = (C) => {
      r == null || r(m, C);
    }, m.onmessage = (C) => {
      if (n.heartbeat) {
        k();
        const {
          message: L = Tt
        } = ve(n.heartbeat);
        if (C.data === L)
          return;
      }
      u.value = C.data, i == null || i(m, C);
    };
  };
  if (n.heartbeat) {
    const {
      message: m = Tt,
      interval: C = 1e3,
      pongTimeout: L = 1e3
    } = ve(n.heartbeat), { pause: X, resume: f } = Er(
      () => {
        Q(m, !1), B == null && (B = setTimeout(() => {
          F(), y = !1;
        }, L));
      },
      C,
      { immediate: !1 }
    );
    h = X, w = f;
  }
  s && (Z && Ut("beforeunload", () => F()), le(F));
  const v = () => {
    !Z && !_r || (F(), y = !1, A = 0, R());
  };
  return a && v(), J(p, v), {
    data: u,
    status: d,
    close: F,
    send: Q,
    open: v,
    ws: g
  };
}
function Wr(e = {}) {
  const {
    window: n = Se,
    initialWidth: t = Number.POSITIVE_INFINITY,
    initialHeight: o = Number.POSITIVE_INFINITY,
    listenOrientation: r = !0,
    includeScrollbar: i = !0
  } = e, a = x(t), s = x(o), l = () => {
    n && (i ? (a.value = n.innerWidth, s.value = n.innerHeight) : (a.value = n.document.documentElement.clientWidth, s.value = n.document.documentElement.clientHeight));
  };
  if (l(), Hr(l), Ut("resize", l, { passive: !0 }), r) {
    const u = Ir("(orientation: portrait)");
    J(u, () => l());
  }
  return { width: a, height: s };
}
function $r(e, n = console) {
  const {
    status: t,
    data: o,
    send: r,
    open: i,
    close: a
  } = Rr(e, {
    autoClose: !0,
    immediate: !1,
    autoReconnect: !1,
    heartbeat: {
      interval: 6e4,
      message: JSON.stringify({
        heartbeat: !0
      }),
      pongTimeout: 5e3
    },
    onConnected: (l) => {
      n.debug("THN: KITT Agent connected", l);
    },
    onDisconnected: (l) => {
      n.debug("THN: KITT Agent disconnected", l);
    },
    onMessage: (l, u) => {
      n.debug("THN: KITT Agent message", u);
    },
    onError: (l, u) => {
      n.debug("THN: KITT Agent error", l, u);
    }
  });
  return {
    isConnected: M(() => t.value === "OPEN"),
    message: o,
    sendWebSocketMessage: r,
    openWebSocketConnection: i,
    closeConnection: a
  };
}
const Or = /* @__PURE__ */ ye({
  __name: "KittChatWidget",
  props: {
    config: {}
  },
  setup(e, { expose: n }) {
    Xt((f) => {
      var S, $, j, W;
      return {
        fc67800c: F.value,
        "2c7fa42f": ($ = (S = z(B)) == null ? void 0 : S.actionColor) == null ? void 0 : $.base,
        "2c85da32": (W = (j = z(B)) == null ? void 0 : j.actionColor) == null ? void 0 : W.over
      };
    });
    const t = e, o = M(() => t.config.logger || console), r = Fe(
      () => import("./chunks/KittChatDesktop.B5DYck3x.js")
    ), i = Fe(
      () => import("./chunks/KittChatMobile.DiHpvH2F.js")
    ), a = M(() => {
      var f;
      return !!((f = t.config) != null && f.deviceStyleConfig) && !Array.isArray(t.config.deviceStyleConfig);
    }), s = M(() => ({
      language: t.config.language,
      site_id: t.config.siteId,
      kitt_id: t.config.kittId,
      country: t.config.country || "",
      device: t.config.device,
      fingerprint: t.config.fingerprint
    })), {
      isConnected: l,
      message: u,
      sendWebSocketMessage: d,
      openWebSocketConnection: g,
      closeConnection: p
    } = $r(t.config.endpoint), h = x([]), w = x(!1), y = x(), A = x(), E = x({}), B = an(), U = M(() => {
      switch (t.config.device) {
        case "mobile":
          return i;
        case "tablet":
          return i;
        default:
          return r;
      }
    }), k = M(() => {
      var ee, te, D, O, ne, Me, xe, _e, Ae, ke, Le, Te, He;
      const f = ((D = (te = (ee = t.config) == null ? void 0 : ee.deviceStyleConfig) == null ? void 0 : te.basics) == null ? void 0 : D.mainColor) || "#007AFF", S = ((Me = (ne = (O = t.config) == null ? void 0 : O.deviceStyleConfig) == null ? void 0 : ne.extra) == null ? void 0 : Me.actionColor) || "#007AFF", $ = ((Ae = (_e = (xe = t.config) == null ? void 0 : xe.deviceStyleConfig) == null ? void 0 : _e.extra) == null ? void 0 : Ae.borderRadius) || t.config.deviceStyleConfig.cornerRadius || "8", j = ((Le = (ke = t.config) == null ? void 0 : ke.deviceStyleConfig) == null ? void 0 : Le.initialStatus) === void 0 || t.config.deviceStyleConfig.initialStatus === "closed", W = ((He = (Te = t.config) == null ? void 0 : Te.deviceStyleConfig) == null ? void 0 : He.position) || "LR";
      return {
        payload: {
          ...t.config,
          basics: {
            mainColor: f
          },
          extra: {
            actionColor: S,
            border: "0",
            borderColor: f,
            borderRadius: $
          },
          showClosed: j,
          position: W
        },
        i18n: {
          locale: t.config.language,
          messages: E.value,
          pluralRules: Zn
        }
      };
    }), F = M(() => t.config.isRightAlign ? "rtl" : "ltr");
    function Q() {
      var f;
      (f = A.value) != null && f.collapse && A.value.collapse();
    }
    function R(f) {
      return we(f);
    }
    function v() {
      l.value || (g(), d(
        JSON.stringify({
          ...s.value
        })
      ));
    }
    function m(f, S) {
      if (l.value || g(), d(
        JSON.stringify({
          messages: [
            {
              role: S || G.USER,
              content: typeof f == "string" ? f : JSON.stringify(f)
            }
          ],
          ...s.value
        })
      ), S === G.SYSTEM) return;
      h.value.push({
        id: Lt(),
        content: R(typeof f == "string" ? f : f.content),
        owner: S || G.USER
      });
      const $ = Lt();
      h.value.push({
        id: $,
        owner: G.ASSISTANT,
        content: "",
        loading: !0
      });
    }
    function C(f, S) {
      m(f, S);
    }
    const L = x();
    de(Mr, {
      messages: h,
      isConnected: l,
      sendMessage: m,
      openConnection: v,
      syncMessagesScroll: L,
      closeConnection: p
    }), J(u, () => {
      var W, ee, te;
      const f = JSON.parse(u.value);
      if (((W = f.choices) == null ? void 0 : W.length) === 0) return;
      if (f.choices.length > 1) {
        h.value = [], f.choices.forEach(
          (D) => {
            let O = D.message.content;
            if (D.message.role === G.USER)
              try {
                O = JSON.parse(O).content;
              } catch (ne) {
                o.value.error(
                  "Failed to parse JSON content",
                  O,
                  ne
                );
              }
            (O == null ? void 0 : O.trim().length) > 0 && h.value.push({
              id: f.id,
              owner: D.message.role,
              content: R(O)
            });
          }
        );
        return;
      }
      if (h.value.length === 1 && f.choices[0].finish_reason === null)
        return;
      const S = (ee = f.choices[0]) == null ? void 0 : ee.message.content, $ = (te = f.choices[0]) == null ? void 0 : te.message.role, j = h.value.findIndex((D) => D.loading);
      j !== -1 && h.value.splice(j, 1), S && h.value.push({
        id: f.id,
        owner: $ || G.ASSISTANT,
        content: R(S)
      }), typeof L.value == "function" && L.value();
    }), J(
      () => t.config.language,
      async (f) => {
        try {
          const S = await rn(/* @__PURE__ */ Object.assign({ "./locales/ar.json": () => import("./chunks/ar.nvGRuIs5.js"), "./locales/bg.json": () => import("./chunks/bg.DoNTpCL4.js"), "./locales/ca.json": () => import("./chunks/ca.qqEtv98c.js"), "./locales/cs.json": () => import("./chunks/cs.DDdoz_wR.js"), "./locales/da.json": () => import("./chunks/da.BLrX9CSi.js"), "./locales/de.json": () => import("./chunks/de.BhOyzjb4.js"), "./locales/el.json": () => import("./chunks/el.qRKnc819.js"), "./locales/en.json": () => import("./chunks/en.5B0BABAZ.js"), "./locales/es.json": () => import("./chunks/es.CUKEOLg4.js"), "./locales/et.json": () => import("./chunks/et.B4w-QvJj.js"), "./locales/eu.json": () => import("./chunks/eu.CBPCyVrq.js"), "./locales/fi.json": () => import("./chunks/fi.C_p7rThw.js"), "./locales/fr.json": () => import("./chunks/fr.C7QxVOkD.js"), "./locales/he.json": () => import("./chunks/he.Vn_ktRbj.js"), "./locales/hr.json": () => import("./chunks/hr.DcBzeC4V.js"), "./locales/hu.json": () => import("./chunks/hu.Dyo1X_yd.js"), "./locales/id.json": () => import("./chunks/id.CL3ADAlz.js"), "./locales/is.json": () => import("./chunks/is.BNjzY8Zp.js"), "./locales/it.json": () => import("./chunks/it.CemFLbkO.js"), "./locales/ja.json": () => import("./chunks/ja.CBYYETHL.js"), "./locales/ko.json": () => import("./chunks/ko.BCf-4NnS.js"), "./locales/lt.json": () => import("./chunks/lt.BTOBA0we.js"), "./locales/nl.json": () => import("./chunks/nl.Dv3U-WCB.js"), "./locales/no.json": () => import("./chunks/no.D_Y844MU.js"), "./locales/pl.json": () => import("./chunks/pl.BilPcrGy.js"), "./locales/pt.json": () => import("./chunks/pt.ByczII8a.js"), "./locales/ro.json": () => import("./chunks/ro.CJmdD5C2.js"), "./locales/ru.json": () => import("./chunks/ru.15nj5NNp.js"), "./locales/sl.json": () => import("./chunks/sl.D2o8EPGP.js"), "./locales/sv.json": () => import("./chunks/sv.ojhq68Da.js"), "./locales/th.json": () => import("./chunks/th.CMRdoP9Z.js"), "./locales/tr.json": () => import("./chunks/tr.gQB0i0bZ.js"), "./locales/uk.json": () => import("./chunks/uk.BFk78nrF.js"), "./locales/vi.json": () => import("./chunks/vi.B2rl_WFc.js"), "./locales/zh-TW.json": () => import("./chunks/zh-TW.B2zKxcNP.js"), "./locales/zh.json": () => import("./chunks/zh.DfkIz3JT.js") }), `./locales/${f}.json`, 3);
          E.value = {
            [f]: S.default
          };
        } catch {
          E.value = {}, console.warn("THN: Error loading i18n messages");
        }
      },
      { immediate: !0 }
    );
    function X() {
      p();
    }
    return Nt(async () => {
      p();
    }), n({
      collapse: Q,
      destroy: X
    }), (f, S) => a.value ? (Ne(), Zt("div", {
      key: 0,
      ref_key: "rootEl",
      ref: y,
      class: "thn--widget thn--widget-kittchat root w-full"
    }, [
      ze(z(nr), { config: k.value }, {
        default: Ie(() => [
          ze(xr, {
            config: k.value.payload
          }, {
            default: Ie(({ config: $ }) => [
              (Ne(), en(tn(U.value), {
                ref_key: "widget",
                ref: A,
                modelValue: h.value,
                "onUpdate:modelValue": S[0] || (S[0] = (j) => h.value = j),
                "is-typing": w.value,
                config: $,
                onSendMessage: C
              }, null, 40, ["modelValue", "is-typing", "config"]))
            ]),
            _: 1
          }, 8, ["config"])
        ]),
        _: 1
      }, 8, ["config"])
    ], 512)) : nn("", !0);
  }
}), Br = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [o, r] of n)
    t[o] = r;
  return t;
}, qr = /* @__PURE__ */ Br(Or, [["__scopeId", "data-v-8dca28b6"]]);
export {
  G as M,
  Dr as N,
  Pr as R,
  Br as _,
  ln as a,
  Mr as b,
  Vr as chatIconList,
  Dt as chatIconMap,
  qr as default,
  Lt as g,
  Ur as getIconComponent,
  gr as i,
  Sr as k,
  an as s,
  sn as t,
  Wr as u
};
//# sourceMappingURL=kittchat.es.js.map
